export default __webpack_public_path__ + "static/barlow-v4-latin-600-b67e04d54973e392f660260cceeefe9e.eot";